module.exports = __webpack_public_path__ + "static/img/4.239c536.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/management/4.png
// module id = F4qM
// module chunks = 7